<template>
  <section class="content d-flex flex-column justify-content-center align-items-center maintenance-page">
    <b-container fluid="sm">
      <img :src="threeDoctorsSVG" class="mb-5 three-doctors-svg" />
      <h1 class="mb-3">RapiDr has moved to a new website! Same price from $8.90 per consult, even better experience.</h1>
      <p>Hello!✨️</p>
        <p> We are open! You're seeing this screen cause we have moved from our website. You can only raise teleconsults via RapiDr via our iOS and Android applications.
 We understand it's a small bummer. but it's the only way for us to provide you with the best experience we can.</p>
        <p><b>Visit us at <a href="https://home.rapidr.sg">home.rapidr.sg</a></b></p>  
        <p>Download the RapiDr App here ⬇️</p>
        <p>
          <a
            href="https://play.google.com/store/apps/details?id=com.rapidr&hl=en_SG"
            target="_blank"
            rel="noopener noreferrer"
          ><img :src="googlePlayBadge" alt="Get it on Google Play" class="store-badge" /></a>
        </p>
        <p>
          <a
            href="https://apps.apple.com/sg/app/rapidr/id6661022017"
            target="_blank"
            rel="noopener noreferrer"
          ><img :src="appStoreBadge" alt="Download on the App Store" class="store-badge" /></a>
        </p>
      <p>For help, please contact our helpdesk at <a href="https://wa.me/6588013277">+65 88013277</a> on WhatsApp and we will gladly assist you ✨</p>
    </b-container>
  </section>
</template>

<script>
export default {
  data() {
    return {
      threeDoctorsSVG: require("@/assets/three-doctors.svg"),
      googlePlayBadge: require("@/assets/google-play-removebg-preview.png"),
      appStoreBadge: require("@/assets/app-store-removebg-preview.png"),
    };
  },
  methods: {
    maintenanceContactForm() {
      window.open("https://forms.gle/ioZa5fiT3HHcPUSLA", "_blank");
    },
  },
};
</script>

<style>
.maintainance-page {
  height: 100vh;
  font-size: 2rem;
  font-weight: 600;
}

.three-doctors-svg {
  max-width: 500px;
}

.hyperlink {
  color: blue;
  text-decoration: underline;
}

.store-badge {
  height: 50px;
}
</style>
